<template>
  <div
    class="product-name-container"
    @mouseenter="showActions = true"
    @mouseleave="showActions = false"
    @touchstart="handleTouch"
  >
    <a href="#" class="product-name text-primary" :class="{ 'pna--deleted': is_deleted }" @click.prevent="openProduct">
      <template v-if="name_short">
        <CIcon name="cil-lightbulb" size="sm" v-c-tooltip="{ content: name }" /> {{ name_short }}
      </template>
      <template v-else>
        {{ name }}
      </template>
    </a>
    <CBadge v-if="is_deleted" color="danger" class="pna-deleted-badge ml-1">{{ $t('product.deleted') }}</CBadge>

    <div
      class="action-buttons"
      :class="{ 'show': showActions }"
    >
      <CButton
        size="sm"
        variant="ghost"
        class="action-btn quick-edit-btn"
        @click="openQuickEdit"
        v-c-tooltip="$t('product.edit_product')"
      >
        <CIcon name="cil-pencil" size="sm" />
      </CButton>

      <CButton
        v-if="normalizedEquivalentProductsCount > 0"
        size="sm"
        variant="ghost"
        class="action-btn equivalent-products-btn"
        @click="openEquivalentProducts"
        v-c-tooltip="$t('product.equivalent_products')"
      >
        <CIcon name="cil-link" size="sm" />
        <span class="equivalent-products-count">{{ normalizedEquivalentProductsCount }}</span>
      </CButton>

      <!-- <CButton
        size="sm"
        variant="ghost"
        class="action-btn preview-btn"
        @click="openPreview"
        v-c-tooltip="$t('product.preview')"
      >
        <CIcon name="cil-magnifying-glass" size="sm" />
      </CButton> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductNameWithActions",
  props: {
    id: {
      type: [Number, String],
      required: true
    },
    name: {
      type: String,
      required: true
    },
    name_short: {
      type: String,
      required: false
    },
    is_deleted: {
      type: Boolean,
      default: false
    },
    equivalentProductsCount: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      showActions: false,
      touchTimeout: null
    }
  },
  computed: {
    normalizedEquivalentProductsCount() {
      return Number(this.equivalentProductsCount || 0);
    },
  },

  methods: {
    openProduct() {
      const productId = parseInt(this.id, 10);
      if (this.$listeners.open) {
        this.$emit("open", productId);
        return;
      }

      this.$store.commit('set', ['productEditModalId', productId]);
    },

    openQuickEdit() {
      this.$store.commit('set', ['asideProductQuickEditTab', 'edit']);
      this.$store.commit('set', ['asideProductQuickEditId', parseInt(this.id)]);
    },

    openEquivalentProducts() {
      this.$store.commit('set', ['asideProductQuickEditTab', 'equivalents']);
      this.$store.commit('set', ['asideProductQuickEditId', parseInt(this.id)]);
    },

    openPreview() {
      this.$store.commit('set', ['viewProductModalId', parseInt(this.id)]);
    },

    handleTouch() {
      // Mobile touch desteği
      if (this.touchTimeout) {
        clearTimeout(this.touchTimeout);
      }

      this.showActions = true;

      // 3 saniye sonra otomatik gizle
      this.touchTimeout = setTimeout(() => {
        this.showActions = false;
      }, 3000);
    }
  },

  beforeDestroy() {
    // Cleanup
    if (this.touchTimeout) {
      clearTimeout(this.touchTimeout);
    }
  }
}
</script>

<style scoped>
.product-name-container {
  position: relative;
  display: inline-flex;
  align-items: center;
  max-width: 100%;
}

.product-name {
  flex: 1;
  min-width: 0; /* Flexbox için gerekli */
  word-break: break-word;
  line-height: 1.4;
}

.action-buttons {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  margin-left: 0.5rem;
  opacity: 0;
  transform: translateX(-10px);
  transition: all 0.3s ease;
  pointer-events: none;
}

.action-buttons.show {
  opacity: 1;
  transform: translateX(0);
  pointer-events: auto;
}

.action-btn {
  min-width: 32px;
  height: 32px;
  padding: 0.25rem;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.action-btn:hover {
  transform: scale(1.1);
}

.quick-edit-btn {
  background-color: rgba(32, 201, 151, 0.2);
  color: #1ea579;
  border: 1px solid rgba(32, 201, 151, 0.3);
}

.quick-edit-btn:hover {
  background-color: rgba(32, 201, 151, 0.35);
  color: #17a371;
  border-color: rgba(32, 201, 151, 0.5);
}

.preview-btn {
  background-color: rgba(23, 162, 184, 0.2);
  color: #138496;
  border: 1px solid rgba(23, 162, 184, 0.3);
}

.preview-btn:hover {
  background-color: rgba(23, 162, 184, 0.35);
  color: #0f6674;
  border-color: rgba(23, 162, 184, 0.5);
}

.equivalent-products-btn {
  position: relative;
  background-color: rgba(50, 31, 219, 0.12);
  color: #321fdb;
  border: 1px solid rgba(50, 31, 219, 0.22);
}

.equivalent-products-btn:hover {
  background-color: rgba(50, 31, 219, 0.22);
  color: #2819b8;
  border-color: rgba(50, 31, 219, 0.36);
}

.equivalent-products-count {
  position: absolute;
  top: -6px;
  right: -6px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 999px;
  background: #e55353;
  color: #fff;
  font-size: 0.62rem;
  font-weight: 700;
  line-height: 16px;
  text-align: center;
  box-shadow: 0 0 0 2px #fff;
}

/* Responsive düzen */
@media (max-width: 768px) {
  .action-buttons {
    gap: 0.125rem;
    margin-left: 0.25rem;
  }

  .action-btn {
    min-width: 28px;
    height: 28px;
    padding: 0.125rem;
  }
}

/* Touch cihazlar için */
@media (hover: none) and (pointer: coarse) {
  .product-name-container {
    padding-right: 105px; /* Butonlar icin yer ayir */
  }

  .action-buttons {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    opacity: 0;
    pointer-events: none;
  }

  .action-buttons.show {
    opacity: 1;
    transform: translateY(-50%);
    pointer-events: auto;
  }
}

/* Animasyon performansı için */
.action-buttons,
.action-btn {
  will-change: transform, opacity;
}

.pna--deleted {
  text-decoration: line-through;
  opacity: 0.7;
}

.pna-deleted-badge {
  font-size: 0.62rem;
  padding: 0.12em 0.4em;
  vertical-align: middle;
  flex-shrink: 0;
}
</style>
